import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import Logo from "@/components/Logo";

/** 404 — "you wandered off the plan". Yellow CTA to Tracker. */
export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen bg-black text-white flex flex-col">
      <header className="border-b border-white/10 px-4 sm:px-6 py-4">
        <Link to="/" className="flex items-center gap-2"><Logo /></Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-lg w-full text-center">
          <div className="inline-flex items-center justify-center h-16 w-16 border border-[#E2E30A]/40 bg-[#E2E30A]/10 mb-6">
            <Compass className="h-8 w-8 text-[#E2E30A]" />
          </div>
          <p className="text-[11px] uppercase tracking-[0.4em] text-[#E2E30A] mb-3">404 · Off the plan</p>
          <h1 className="font-display text-4xl sm:text-6xl uppercase tracking-tight leading-none mb-4">
            You wandered off the plan
          </h1>
          <p className="text-zinc-300 mb-8">
            That page doesn't exist — no shame, even elite athletes miss the turn. Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-3">
            <Link to="/tracker" data-testid="not-found-tracker-btn"
              className="inline-flex items-center justify-center px-6 py-3 bg-[#E2E30A] hover:bg-[#c9ca09] text-black font-display uppercase tracking-widest text-sm transition-colors">
              Back to Tracker
            </Link>
            <Link to="/" data-testid="not-found-home-btn"
              className="inline-flex items-center justify-center px-6 py-3 border border-white/20 hover:border-white/50 text-white font-display uppercase tracking-widest text-sm transition-colors">
              Home
            </Link>
          </div>
          <p className="text-[11px] text-zinc-500 mt-8 tracking-wider uppercase">
            Pro tip · tap the SPC badge 5 times to unlock a little something
          </p>
        </div>
      </main>
    </div>
  );
}
